import React, { useRef, useEffect } from "react";

const TextField = ({ question, answer, onAnswer }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    // Auto-focus the input when this question appears
    const timer = setTimeout(() => inputRef.current?.focus(), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="tbb-quiz__field">
      <input
        ref={inputRef}
        type="text"
        className="tbb-quiz__text-input"
        placeholder={question.placeholder || "Type your answer..."}
        value={answer || ""}
        onChange={(e) => onAnswer(e.target.value)}
        maxLength={question.validation?.maxLength || 100}
        autoComplete="off"
      />
    </div>
  );
};

export default TextField;
